import Vue from 'vue';
import ifndef from './ifndef';
import relative from './relative';
import local from './local';
import time from './time';
import datetime from './datetime';


export default {
  register() {
    Vue.filter('ifndef', ifndef);
    Vue.filter('relative', relative);
    Vue.filter('local', local);
    Vue.filter('time', time);
    Vue.filter('datetime', datetime);
  }
};
